import { createContext } from 'react'

export enum ViewportOrientationValues {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}

export enum ViewportTypeValues {
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  MOBILE = 'mobile',
}

export interface ViewportDimensions {
  width: number
  height: number
}

export interface ViewportOrientation {
  orientation: ViewportOrientationValues
}

export interface ViewportType {
  type: ViewportTypeValues
}

export type Viewport = ViewportDimensions & ViewportOrientation & ViewportType

export type ViewportWidthContextType = Viewport['width']
export type ViewportHeightContextType = Viewport['height']
export type ViewportTypeContextType = Viewport['type']
export type ViewportOrientationContextType = Viewport['orientation']

const ViewportWidthContext = createContext<ViewportWidthContextType>(0)
const ViewportHeightContext = createContext<ViewportHeightContextType>(0)
const ViewportTypeContext = createContext<ViewportTypeContextType>(
  ViewportTypeValues.DESKTOP
)
const ViewportOrientationContext =
  createContext<ViewportOrientationContextType>(
    ViewportOrientationValues.PORTRAIT
  )

const exports = {
  ViewportWidthContext,
  ViewportHeightContext,
  ViewportTypeContext,
  ViewportOrientationContext,
}

export default exports
